import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLive } from "@/context/Realtime";

export function useFetch(url, { poll, live } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!url) return;
    try {
      const { data: d } = await api.get(url);
      setData(d);
    } catch (e) {
      setData((prev) => prev);
    } finally {
      setLoading(false);
    }
  }, [url]);
  useEffect(() => {
    reload();
    if (!poll) return undefined;
    const t = setInterval(reload, poll);
    return () => clearInterval(t);
  }, [reload, poll]);
  useLive((e) => {
    if (live && (e.type === "reconnect" || live(e))) reload();
  });
  return { data, loading, reload, setData };
}
